import { RouteConfig } from "vue-router";

const HomeRoute: Array<RouteConfig> = [
  {
    path: "/admin",
    component: () => import("@/views/admin/home/Index.vue")
  }
];

export { HomeRoute };
